export default IconArrowMoveRight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-move-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11 12h10" />
  <path d="M18 9l3 3l-3 3" />
  <path d="M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z" />
</svg>`;